import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import AutomotiveProcessFlow from "./AutomotiveProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  AUTOMOTIVE_DOMAIN_INTRO,
  AUTOMOTIVE_GROUPS,
  AUTOMOTIVE_USE_CASES_SEO,
  AUTOMOTIVE_DOMAIN_FAQS,
  AUTOMOTIVE_ITEM_LIST_JSONLD,
  AUTOMOTIVE_BREADCRUMB_JSONLD,
  AUTOMOTIVE_WEBPAGE_JSONLD,
  AUTOMOTIVE_FAQ_JSONLD,
} from "../../data/automotiveUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<AutomotiveProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = AUTOMOTIVE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function AutomotiveDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? AUTOMOTIVE_GROUPS : AUTOMOTIVE_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={AUTOMOTIVE_DOMAIN_INTRO}
        domainSlug="automotive-domain"
        useCaseCount={AUTOMOTIVE_USE_CASES_SEO.length}
        groupCount={AUTOMOTIVE_GROUPS.length}
        itemListJsonLd={AUTOMOTIVE_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={AUTOMOTIVE_BREADCRUMB_JSONLD}
        faqJsonLd={AUTOMOTIVE_FAQ_JSONLD}
        webPageJsonLd={AUTOMOTIVE_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{AUTOMOTIVE_DOMAIN_INTRO.title}</h1>
          {AUTOMOTIVE_DOMAIN_INTRO.content ? <p>{AUTOMOTIVE_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={AUTOMOTIVE_USE_CASES_SEO} groups={AUTOMOTIVE_GROUPS} heading="Automotive Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={AUTOMOTIVE_DOMAIN_INTRO.title}
        domainFaqs={AUTOMOTIVE_DOMAIN_FAQS}
        useCases={AUTOMOTIVE_USE_CASES_SEO}
      />
    </div>
  );
}

